import { render, staticRenderFns } from "./AppointmentNewSpaceCoordinationWrapper.vue?vue&type=template&id=6e3c6083"
import script from "./AppointmentNewSpaceCoordinationWrapper.vue?vue&type=script&lang=js"
export * from "./AppointmentNewSpaceCoordinationWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports